import Constants from 'js/Constants';
import { CONNECTION_CATEGORY_FILE } from 'js/constants/connectionCategories';

export default function createFileSystemService() {
  function getSinkFieldsForFile(sinkFields) {
    if (!sinkFields) return [];
    return sinkFields.filter(
      (f) =>
        f.name !== 'data_format' &&
        f.name !== 'file.name.prefix' &&
        f.name !== 'orc.compress' &&
        f.name !== 'max.file.size.mb' &&
        f.name !== 'xml.root' &&
        f.name !== 'write.header' &&
        f.name !== 'field.lengths' &&
        f.name !== 'padding.character' &&
        f.name !== 'line.separator' &&
        f.name !== 'range' &&
        f.name !== 'insert.mode' &&
        f.name !== 'clear.range' &&
        !Constants.HC_SINK_FIELD_NAMES.includes(f.name),
    );
  }

  function getSinkName(selectedBucket) {
    return (connectionCategory) => {
      if (connectionCategory === CONNECTION_CATEGORY_FILE) {
        let leafNodeName;

        if (selectedBucket && (selectedBucket.displayName || selectedBucket.name)) {
          leafNodeName = selectedBucket.displayName || selectedBucket.name;
        } else if (selectedBucket && (selectedBucket.displayPath || selectedBucket.path)) {
          const path = selectedBucket.displayPath || selectedBucket.path;
          leafNodeName = path.substr(path.lastIndexOf('/') + 1);
        }

        //TODO: ftp etc source types have bucket name /. Need backend to change the types maybe?
        return leafNodeName;
      }
    };
  }

  function getInitialSourceConfig() {
    return (connectionCategory, sourceConfig, sourceConfigFields) => {
      if (
        connectionCategory === CONNECTION_CATEGORY_FILE &&
        sourceConfigFields.some((f) => f.name === 'ignore.files.older.than.ms')
      ) {
        return {
          ...sourceConfig,
          'ignore.files.older.than.ms':
            sourceConfig['ignore.files.older.than.ms'] || Date.now() - 7 * 24 * 3600 * 1000,
        };
      }
      return sourceConfig;
    };
  }

  function getBucketConfig(bucket) {
    const path = bucket?.path;
    const displayPath = bucket?.displayPath;
    const mimeType = bucket?.mimeType;
    return {
      path,
      'ui.display_path': displayPath,
      'ui.selected_file_mime_type': mimeType,
    };
  }

  return {
    getSinkFieldsForFile,
    getInitialSourceConfig,
    getSinkName,
    getBucketConfig,
  };
}
